<template>
  <div
  class="login full-width flexbox align-center justify-center full-height">
    <div class="">
      <div class="text-center mt-5">
        <el-badge :value="$t('operator_panel')" class="item">
          <img
          src="https://static.newsbx.com/newsbx/logo/logo-colored.svg"
          height="44"/>
        </el-badge>
      </div>
      <el-card style="width:360px" class="mt-15">
        <el-form
        label-position="top"
        :model="form"
        :rules="rules"
        ref="loginForm"
        :disabled="loading">
          <el-form-item
          prop="username">
            <el-input
            v-model="form.username"
            :placeholder="$t('username')"
            autofocus
            clearable
            class="tahoma"/>
          </el-form-item>
          <el-form-item
          prop="password">
            <el-input
            v-model="form.password"
            :type="passwordVisible ? 'text' : 'password'"
            :placeholder="$t('password')"
            class="tahoma">
              <i slot="prefix"
              :class="`searchable
              el-input__icon fas fa-eye${passwordVisible ? '-slash' : ''}`"
              @click="passwordVisible = !passwordVisible"></i>
            </el-input>
          </el-form-item>
          <el-form-item class="no-margin">
            <el-button
            type="primary"
            class="full-width"
            @click="submitForm('loginForm')"
            :loading="loading">
              {{ $t('sign_in') }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      loading: false,
      passwordVisible: false,
      rules: {
        username: [{
          required: true,
          message: this.$i18n.t('field_required'),
          trigger: 'change'
        }],
        password: [{
          required: true,
          message: this.$i18n.t('field_required'),
          trigger: 'change'
        }]
      },
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    handleAuthSuccess () {
      this.$router.push({
        name: 'home'
      })
    },
    handleAuthRequest () {
      let data = new FormData()
      let { form } = this
      let { username, password } = form
      data.append('username', username)
      data.append('password', password)
      data.append('grant_type', 'password')
      data.append('client_id', process.env.VUE_APP_CLIENT_ID)
      this.toggleLoading()
      this.handleRequest({
        name: 'auth/token',
        action: 'create',
        mutation: 'AUTH_SUCCESS',
        data
      }).then(this.handleAuthSuccess)
        .finally(this.toggleLoading)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleAuthRequest()
        } else {
          return false
        }
      })
    },
    handleKeyPress (e) {
      let { key } = e
      if (key === 'Enter') {
        this.submitForm('loginForm')
      }
    }
  },
  created () {
    document.addEventListener('keypress', this.handleKeyPress)
  },
  beforeDestroy () {
    document.removeEventListener('keypress', this.handleKeyPress)
  }
}
</script>
